module.exports = __webpack_public_path__ + "static/media/gls_leg_l.967c930e.png";